/**
 * Klassennamen zusammensetzen. Bewusst ohne `tailwind-merge` — die
 * Komponenten geben ihre Grundklassen so aus, dass Aufrufer sie ergänzen und
 * nicht überschreiben müssen.
 */
export const cn = (...teile: Array<string | false | null | undefined>): string =>
  teile.filter(Boolean).join(' ');
